import React from "react";

interface QuantityStepperProps {
  quantity: number;
  onIncrement: () => void;
  onDecrement: () => void;
  disabled?: boolean;
}

const QuantityStepper: React.FC<QuantityStepperProps> = ({
  quantity,
  onIncrement,
  onDecrement,
  disabled = false,
}) => {
  return (
    <div className="quantity-stepper">
      <button onClick={onDecrement} disabled={disabled}>
        -
      </button>
      <span>{quantity}</span>
      <button onClick={onIncrement} disabled={disabled}>
        +
      </button>
    </div>
  );
};

export default QuantityStepper;
